import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-date__label"
}
const _hoisted_2 = ["data-date-menu"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_inline_date_sections = _resolveComponent("inline-date-sections")!

  return (_openBlock(), _createElementBlock("span", {
    ref: "rootRef",
    class: _normalizeClass(["inline-date", { 'inline-date--compact': _ctx.compact, 'inline-date--bordered': _ctx.bordered }]),
    onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFieldMouseDown && _ctx.onFieldMouseDown(...args)))
  }, [
    (_ctx.bordered && _ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.showCalendar && _ctx.editable)
      ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 1,
          class: "inline-date__icon",
          name: "calendar",
          width: _ctx.iconSize,
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          onClick: _withModifiers(_ctx.toggleCalendar, ["stop","prevent"])
        }, null, 8, ["width", "onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_inline_date_sections, {
      ref: "dateGroupRef",
      id: `${_ctx.id}-date`,
      sections: _ctx.dateSections,
      separator: ".",
      values: _ctx.dateValues,
      editable: _ctx.editable,
      "enable-menu": _ctx.showCalendar && _ctx.editable,
      "move-to-body": _ctx.moveToBody,
      "menu-z-index": _ctx.menuZIndex,
      "onUpdate:values": _ctx.onDateValues,
      onMenu: _ctx.onDateMenu,
      onStep: _ctx.onStep,
      onEnter: _ctx.onEnter
    }, {
      "menu-content": _withCtx(() => [
        _createElementVNode("div", {
          class: "inline-date__menu",
          "data-date-menu": _ctx.id
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.calendar), {
            "model-value": _ctx.calendarValue,
            "min-date": _ctx.minDate,
            "max-date": _ctx.maxDate,
            "with-time": _ctx.withTime,
            options: _ctx.calendarProps,
            onSelect: _ctx.onCalendarSelect,
            onClose: _ctx.closeCalendar
          }, null, 40, ["model-value", "min-date", "max-date", "with-time", "options", "onSelect", "onClose"]))
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["id", "sections", "values", "editable", "enable-menu", "move-to-body", "menu-z-index", "onUpdate:values", "onMenu", "onStep", "onEnter"]),
    (_ctx.withTime)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "inline-date__gap" }, _toDisplayString(' '), -1)),
          _createVNode(_component_inline_date_sections, {
            ref: "timeGroupRef",
            id: `${_ctx.id}-time`,
            sections: _ctx.timeSections,
            separator: ":",
            values: _ctx.timeValues,
            editable: _ctx.editable,
            "menu-z-index": _ctx.menuZIndex,
            "onUpdate:values": _ctx.onTimeValues,
            onMenu: _ctx.onTimeMenu,
            onStep: _ctx.onStep,
            onEnter: _ctx.onEnter
          }, null, 8, ["id", "sections", "values", "editable", "menu-z-index", "onUpdate:values", "onMenu", "onStep", "onEnter"])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.canClear)
      ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 3,
          class: "inline-date__icon inline-date__icon--clear",
          name: "arrow-left",
          width: _ctx.iconSize,
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          onClick: _withModifiers(_ctx.clearValue, ["stop","prevent"])
        }, null, 8, ["width", "onClick"]))
      : _createCommentVNode("", true)
  ], 34))
}